import { Component, inject, OnInit, signal } from '@angular/core';
import { AgendaService } from '../../../services/business';
import {
  Agenda,
  CreateAgendaDto,
  UpdateAgendaDto,
} from '../../../shared/interfaces';
import { BaseAuthComponent } from '../../../shared/common/BaseAuthComponent.class';
import hexToRgba from '../../../shared/common/utils';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PageTitleService } from '../../../shared/services';
import { ConfirmModal } from '../../../shared/components/confirm-modal/confirm-modal';
import { ScheduleAdd } from './schedule-add/schedule-add';
import { Modal } from '../../../shared/components/modal/modal';

@Component({
  selector: 'app-schedules',
  imports: [CommonModule, RouterLink, ConfirmModal, Modal],
  templateUrl: './schedules.html',
  styleUrl: './schedules.css',
})
export class Schedules extends BaseAuthComponent implements OnInit {
  private readonly agendasApi = inject(AgendaService);
  titleService = inject(PageTitleService);
  agendas = signal<Agenda[]>([]);
  trackById = (_: number, a: Agenda) => a.agendaId;
  confirmOpen = false;
  toDeleteId: string | null = null;
  ScheduleAddForm = ScheduleAdd;
  open = false;
  modalBodyInputs: Record<string, unknown> = {};
  modalTitle = 'Crear nueva agenda';
  isSaving = false;

  ngOnInit(): void {
    this.titleService.setPage({
      title: 'Agendas',
      subtitle: 'Las agendas donde tu equipo recibe citas',
      breadcrumbs: [{ name: 'Configuración', url: '/settings' }],
    });
    this.load();
  }

  load() {
    this.preloader.show();
    this.agendasApi.getAgendas(this.businessId).subscribe({
      next: (list) => {
        this.agendas.set(
          list.map((a) => ({
            ...a,
            colorSoft: hexToRgba(a.color ?? '#000000', 0.08),
          }))
        );
        this.preloader.hide();
      },
      error: (e) => {
        console.log(e);
        this.preloader.hide();
      },
    });
  }

  openDelete(agendaId: string) {
    this.toDeleteId = agendaId;
    this.confirmOpen = true;
  }

  onNewAgenda() {
    this.modalTitle = 'Crear nueva agenda';
    this.modalBodyInputs = {};
    this.open = true;
  }

  onEditAgenda(agendaId: string) {
    this.modalBodyInputs = {
      agendaId,
    };
    this.modalTitle = 'Editar agenda';
    this.open = true;
  }

  onConfirmDelete() {
    if (!this.toDeleteId) return;
    this.agendasApi.deleteAgenda(this.toDeleteId).subscribe({
      next: (res) => {
        this.toastServiceBase.show('Agenda eliminada correctamente', 'success');
        this.load();
      },
      error: (err) => {
        this.toastServiceBase.show(err.message, 'warning', 3000);
        console.error(err);
      },
    });
  }

  onModalConfirm(payload: any) {
    if (!payload) {
      this.open = false;
      return;
    }

    if (!payload.agendaId) {
      this.isSaving = true;
      const body: CreateAgendaDto = {
        businessId: this.businessId,
        professionalId: payload.professionalId,
        name: payload.name,
        description: payload.description,
        color: payload.color,
      };

      this.agendasApi.createAgenda(body).subscribe({
        next: (res) => {
          this.isSaving = false;
          this.open = false;
          this.toastServiceBase.show('Agenda creada correctamente', 'success');
          this.load();
        },
        error: (err) => {
          this.isSaving = false;
          console.error(err);
        },
      });
    } else {
      this.isSaving = true;
      const body: UpdateAgendaDto = {
        name: payload.name,
        description: payload.description,
        color: payload.color,
      };
      this.agendasApi.updateAgenda(payload.agendaId, body).subscribe({
        next: (res) => {
          this.isSaving = false;
          this.open = false;
          this.toastServiceBase.show(
            'Agenda actualizada correctamente',
            'success'
          );
          this.load();
        },
        error: (err) => {
          this.isSaving = false;
          console.error(err);
        },
      });
    }
  }
}
